<div class="arrivals-board-container">

  <!-- ── PAGE HEADER ─────────────────────────────────────────────────── -->
  <div class="board-header">
    <div class="board-header-left">
      <h2 class="board-title">Arrivals Board</h2>
      <span class="board-date">{{todayStr}}</span>
    </div>
    <div class="board-header-right">
      <span class="refresh-info" *ngIf="lastRefreshed">
        Last refreshed: {{lastRefreshed | date:'h:mm:ss a'}}
      </span>
      <button mat-stroked-button (click)="manualRefresh()" [disabled]="loading" class="btn-refresh">
        <mat-icon>refresh</mat-icon> Refresh Now
      </button>
      <button mat-stroked-button
        [class.btn-autorefresh-on]="autoRefreshEnabled"
        [class.btn-autorefresh-off]="!autoRefreshEnabled"
        (click)="toggleAutoRefresh()">
        <mat-icon>{{autoRefreshEnabled ? 'timer' : 'timer_off'}}</mat-icon>
        Auto-refresh: {{autoRefreshEnabled ? 'On' : 'Off'}}
      </button>
      <button mat-stroked-button (click)="triggerDailyReport()" [disabled]="reportTriggering" class="btn-report">
        <mat-icon>email</mat-icon>
        {{reportTriggering ? 'Sending...' : 'Send Daily Report'}}
      </button>
    </div>
  </div>

  <!-- Report feedback -->
  <div *ngIf="reportMessage" class="report-message"
    [class.report-ok]="!reportMessage.startsWith('Error')"
    [class.report-err]="reportMessage.startsWith('Error')">
    {{reportMessage}}
  </div>

  <!-- ── SUMMARY STRIP ───────────────────────────────────────────────── -->
  <div class="summary-strip">
    <div class="summary-tile tile-total">
      <div class="tile-val">{{totalToday}}</div>
      <div class="tile-lbl">Total Arrivals Today</div>
    </div>
    <div class="summary-tile tile-sent">
      <div class="tile-val">{{smsSent}}</div>
      <div class="tile-lbl">SMS Sent</div>
    </div>
    <div class="summary-tile tile-pending">
      <div class="tile-val">{{smsPending}}</div>
      <div class="tile-lbl">Pending</div>
    </div>
    <div class="summary-tile tile-flagged">
      <div class="tile-val">{{flagged}}</div>
      <div class="tile-lbl">Held / Flagged</div>
    </div>
  </div>

  <!-- ── STATUS LEGEND ──────────────────────────────────────────────── -->
  <div class="legend-row">
    <span class="legend-item"><span class="legend-dot dot-green"></span>SMS sent / Ready</span>
    <span class="legend-item"><span class="legend-dot dot-amber"></span>Pending</span>
    <span class="legend-item"><span class="legend-dot dot-red"></span>Held / Issue</span>
  </div>

  <!-- ── LOADING ────────────────────────────────────────────────────── -->
  <div *ngIf="loading" class="loading-row">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Loading arrivals...</span>
  </div>

  <!-- ── EMPTY STATE ────────────────────────────────────────────────── -->
  <div *ngIf="!loading && arrivals.length === 0" class="empty-state">
    <mat-icon>inbox</mat-icon>
    <p>No arrivals found for today ({{todayStr}}).</p>
  </div>

  <!-- ── ARRIVALS TABLE ─────────────────────────────────────────────── -->
  <div *ngIf="!loading && arrivals.length > 0" class="table-wrapper">
    <table class="arrivals-table">
      <thead>
        <tr>
          <th class="col-bar"></th>
          <th>Property</th>
          <th>Guest</th>
          <th>Party</th>
          <th>Check-In</th>
          <th>Door Code</th>
          <th>Door Code Status</th>
          <th>SMS Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of arrivals" [class]="getRowColorClass(row)">
          <!-- Color bar -->
          <td class="col-bar">
            <div class="color-bar" [class]="getRowColorClass(row) + '-bar'"></div>
          </td>
          <!-- Property -->
          <td>
            <span class="property-code">{{row.propertyCode || '—'}}</span>
          </td>
          <!-- Guest -->
          <td>
            <div class="guest-name">{{row.guestFirstName}} {{row.guestLastName}}</div>
            <div class="guest-phone">{{row.mobilePhone || '—'}}</div>
          </td>
          <!-- Party -->
          <td class="col-center">
            <span class="party-size">{{getPartySize(row)}}</span>
          </td>
          <!-- Check-In -->
          <td class="col-center">
            <span class="checkin-date">{{row.checkInDate | date:'MM/dd/yy'}}</span>
          </td>
          <!-- Door Code value -->
          <td class="col-center">
            <span class="door-code-val">{{row.accessCodeFrontDoor || '—'}}</span>
          </td>
          <!-- Door Code Status badge -->
          <td class="col-center">
            <span class="status-badge" [class]="getDoorCodeBadgeClass(row)">
              {{getDoorCodeLabel(row)}}
            </span>
          </td>
          <!-- SMS Status badge -->
          <td class="col-center">
            <span class="status-badge" [class]="getSmsStatusClass(row)">
              {{getSmsStatusLabel(row)}}
            </span>
            <div *ngIf="row._smsSent && row._lastSmsSentAt" class="sms-sent-time">{{row._lastSmsSentAt}}</div>
            <div *ngIf="row._held && row._holdReason" class="hold-reason">{{row._holdReason}}</div>
          </td>
          <!-- Actions -->
          <td class="col-actions">
            <button mat-stroked-button class="btn-sms" (click)="openSmsDialog(row)"
              title="Send arrival SMS to this guest">
              <mat-icon>sms</mat-icon> SMS
            </button>
            <button mat-stroked-button
              [class.btn-hold-active]="row._held"
              [class.btn-hold-inactive]="!row._held"
              (click)="toggleHold(row)"
              [title]="row._held ? 'Remove hold' : 'Put on hold'">
              <mat-icon>{{row._held ? 'lock_open' : 'lock'}}</mat-icon>
              {{row._held ? 'Unhold' : 'Hold'}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
